import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsShikimoriComponent } from './simple-icons-shikimori.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsShikimoriComponent ],
    exports:      [ SimpleIconsShikimoriComponent ],
    bootstrap:    []
})
export class SimpleIconsShikimoriModule {}
